var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message__alert"},[(_vm.message)?_c('v-alert',{attrs:{"width":"300","close-icon":"mdi-close","dismissible":"","align":"left","type":_vm.message.type}},[_vm._v(_vm._s(_vm.message.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }